import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.PortalUserEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.PortalUserList })));

export default { edit, list };
